var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:cash",
    clipPath: "url(#clip0_36_11008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.5312 0.375H0.09375V22.25H28.5312V0.375ZM26.3438 20.0625H2.28125V2.5625H26.3438V20.0625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.7188 5.84375V24.4375H5.5625V26.625H32.9062V5.84375H30.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.3125 16.676C17.0264 16.676 19.2344 14.274 19.2344 11.3217C19.2344 8.36929 17.0264 5.96734 14.3125 5.96734C11.5986 5.96734 9.39062 8.36922 9.39062 11.3217C9.39062 14.2741 11.5986 16.676 14.3125 16.676ZM14.3125 8.15484C15.8202 8.15484 17.0469 9.57549 17.0469 11.3217C17.0469 13.0678 15.8202 14.4885 14.3125 14.4885C12.8048 14.4885 11.5781 13.0678 11.5781 11.3217C11.5781 9.57549 12.8048 8.15484 14.3125 8.15484ZM4.46875 5.29688H6.65625V17.3281H4.46875V5.29688ZM21.9688 5.29688H24.1562V17.3281H21.9688V5.29688Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_11008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.bd2a87855d51caf0bc2408f419d0d821.svg";
export { ForwardRef as ReactComponent };